<template>
  <div style="background:#f3f3f3;">
      <div class="wapper overf" >
	<div class="part">
       <img src="../../static/img/banner.png" width="100%"  />
	</div>
</div>


<div class="wapper overf">
	<div class="part main-box2" style="background:#fff; padding:50px;">
        
        <div class="tit3"><em><a @click="goHome()">返回首页>></a></em><span>举报须知</span></div>
        <div class="h f18 h44 cGray3 p_t_15">
            <p><em class="f-left" style=" width:3%;">1、</em><span style="float:left; width:97%;">本举报网站主要受理反映领导班子和领导干部违反干部选拔任用工作政策法规选人用人问题的举报。如果您要反映违纪违法、涉法涉诉等其他问题，请直接向纪检监察机关、司法机关、信访部门等有关部门进行反映。</span>  </p>
            <p><em class="f-left" style=" width:3%;">2、</em><span style="float:left; width:97%;">认真填写举报内容。请按照提示和要求，认真填写相关内容。其中，填写“主要问题”栏时，要实事求是、突出重点、不歪曲、不夸大、不编造，写清问题发生的时间、地点、主要经过、后果影响等重点要素，字数限定在800字以内。</span></p>
            <p><em class="f-left" style=" width:3%;">3、</em><span style="float:left; width:97%;">大力提倡实名举报。实名举报时,请按要求完整填写姓名、身份证号、联系电话等信息。 </span> </p>
            <p><em class="f-left" style=" width:3%;">4、</em><span style="float:left; width:97%;">坚决反对诬告陷害。对利用举报捏造事实，对他人进行诬告陷害的，将综合运用有关数据进行甄别筛查、追踪倒查，一经查实，依照有关规定严肃处理；构成犯罪的，移交司法机关作出处理。 </span></p>
            <p><em class="f-left" style=" width:3%;">5、</em><span style="float:left; width:97%;">限制恶意重复举报。为保障举报人的合法权益，提高网上举报的运行效率，本举报网站限制针对同一事项、同一人员的恶意重复举报和垃圾信件，同一举报人每天最多提交3件举报。 </span></p>
            <!-- <p><em class="f-left" style=" width:3%;">6、</em><span style="float:left; width:97%;">为保障举报人的合法权益，限制恶意重复举报和垃圾信件，提高网上举报的运行效益，举报人计算机每天最多只能提交5件举报。 </span></p> -->
　 　
　　             　(系统会自动弹出“安全警报”或“安全证书”对话框，请点击“是”或“继续浏览”进行举报。) 

        </div>
        <div class="h h40 f16 m_t_30"><label style="padding-left:300px;">
            <input name="agree" type="radio" value="1" v-model="checkedvalue" />我同意上述条款</label> <label style="padding-left:150px;">
            <input name="agree" type="radio" value="2" />我不同意上述条款</label></div>
        <div class="m_t_30">
          <a @click="person()" class="button button-caution button-rounded button-large" style="background:#a00; margin-left:250px;">我要举报个人</a>
          <a @click="unit()" class="button button-caution button-rounded button-large" style="background:#a00; margin-left:80px;">我要举报单位</a>
        </div>
        
        
        
	</div>
</div>

<div class="clear overf m_t_40"></div>
<!---- foot ---->
<div class="wapper overf p_b_10" style="background:#AD0C1D;" >
  <div class="part p_t_20 h26 cWhite f14 overf" >
	  <div class="t-center">	
              <p class=" p_l_10 ">
Copyright© 2010.中共湖南省委组织部举报中心 All Rights Reserved 
			  </p>
        <p class=" p_l_10 ">
    备案号：<a href="http://beian.miit.gov.cn/" target="_blank">湘ICP备17016663号-2</a>
                </p>
     </div>
</div>
</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      checkedvalue: '',
      areaCode:'',
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted(){
    this.areaCode=this.$route.query.areaCode
  },
  methods:{
      person(){
        if(this.checkedvalue=='1'){
          this.$router.push({name:'personal',query:{areaCode:this.areaCode},params:{areaCode:this.areaCode}})
        }else{
          alert("需同意上述条款才能进行下一步举报")
        }
      },
      unit(){
        if(this.checkedvalue=='1'){
          this.$router.push({name:'unit',query:{areaCode:this.areaCode},params:{areaCode:this.areaCode}})
        }else{
          alert("需同意上述条款才能进行下一步举报")
        }
      },
      goHome(){
          this.$router.push({name:'index'})
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/notice.vue